import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SearchEffects } from './search.effects';

@NgModule({
  imports: [EffectsModule.forFeature([SearchEffects])],
})
export class SearchStoreModule {}
